import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { CustomActiveFacetsComponent } from './active-facets.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,

    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ActivedFacets: {
          component: CustomActiveFacetsComponent,
        },
      },
    }),
  ],
  declarations: [CustomActiveFacetsComponent],
  exports: [CustomActiveFacetsComponent],
})
export class CustomActiveFacetsModule {}
